export default __webpack_public_path__ + "static/media/wood3.657ae84a.jpg";